import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

class Technician extends React.Component {
  buildUserPicture(url) {
    if (url === "no-tiene") {
      url = "/api/sites/default/files/pictures/default-user-image.png";
      if (window.location.host.includes("localhost")) {
        url = "https://oficina.nadunet.es" + url;
      }
    }
    return (
      <div className={"timeline-badge primary"}>
        <img 
          src={url}
          alt="author-image"
          style={{
            // height: "46px",
            // width: "46px",
            // borderRadius: "23px",
            // marginTop: "-3px"
          }}
        />
      </div>
    );
  }
  render() {
    return (
      <div
        className={
          "timeline" + " technician" +
          (this.props.simple ? " timeline-simple" : "") +
          (this.props.rtl ? " timeline-rtl" : "")
        }
      >
        {this.props.stories.map((prop, key) => {
          return (
            <div className={prop.inverted ? "timeline-inverted" : ""} key={key}>
              <div className="timeline-panel">
                {prop.title ? (
                  <div className="timeline-heading">
                    <span className={"badge badge-" + prop.titleColor}>
                      {prop.badgeUserPicture
                        ? this.buildUserPicture(prop.badgeUserPicture)
                        : null}
                      {prop.title}
                    </span>
                  </div>
                ) : null}
                <div className="timeline-body">{prop.body}</div>
                {prop.footerTitle ? (
                  <h6>
                    <i className={prop.footerIcon} /> {prop.footerTitle}
                  </h6>
                ) : null}
                {prop.footer ? (
                  <div className="timeline-footer">{prop.footer}</div>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

Technician.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.object),
  simple: PropTypes.bool,
  rtl: PropTypes.bool
};

export default Technician;



// WEBPACK FOOTER //
// ./src/components/Technician/Technician.jsx